import { render, staticRenderFns } from "./visao-geral.vue?vue&type=template&id=18d2ee49&scoped=true"
import script from "./visao-geral.vue?vue&type=script&lang=js"
export * from "./visao-geral.vue?vue&type=script&lang=js"
import style0 from "./visao-geral.vue?vue&type=style&index=0&id=18d2ee49&prod&lang=css"
import style1 from "./visao-geral.vue?vue&type=style&index=1&id=18d2ee49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d2ee49",
  null
  
)

export default component.exports